<template>
  <div class="bookcontent">
    <read-picture v-for="(item, index) in imgs" :key="index" :bookid="bookid" :booktitle="booktitle" :chapternum="chapternum" :picparts="item" :picSplitCount="picSplitCount"></read-picture>
    <!--    <img v-for="(item, index) in imgs" :imgpath="getContentImgPath(item)" v-lazy="require('../../../assets/images/loading.jpeg')"/>-->
  </div>
</template>

<script>
  import {getImg} from '../../../services/urlService'
  import ReadPicture from '@/components/layer2/book/read-picture'

  export default {
    name: "readcontent",
    props: {
      bookid: Number,
      booktitle: String,
      chapternum: Number,
      imgs: Array,
      picSplitCount: Number
    },
    components: {
      'read-picture': ReadPicture
    },
    methods: {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layer2/book/read-content.vue